import {useContext, useState} from 'react';
import {TranslateContext} from "../../../../../context/TranslateContext.jsx";
import {useHistory} from "react-router-dom";
import {LoaderContext} from "../../../../../context/LoaderContext.jsx";
import * as Yup from "yup";
import {aggiornaBatchApi, aggiungiBatchApi} from "../../../../../services/SchedulazioniServices";

export const useFormModificaBatch = ({
                                         batch,
                                     }) => {


    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const loader = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();

    const initialFormValues = {
        id_batch: batch?.id_batch?.toString() || '',
        codice: batch?.codice || '',
        descrizione: batch?.descrizione || '',
        endpoint: batch?.endpoint || '',
    };

    const validationSchema = Yup.object().shape({
        descrizione: Yup.string()
            .max(100, traduci('Valore troppo lungo'))
            .required(traduci('Questo campo è obbligatorio')),
        endpoint: Yup.string()
            .max(100, traduci('Valore troppo lungo'))
            .required(traduci('Questo campo è obbligatorio')),
        codice: Yup.string()
            .max(20, traduci('Valore troppo lungo'))
            .required(traduci('Questo campo è obbligatorio')),
    });

    const aggiornBatch = async (values) => {
        loader.startChiamata();
        const response = await aggiornaBatchApi(batch.id_batch, values);
        loader.endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    };

    const aggiungiBatch = async (values) => {
        loader.startChiamata();
        const response = await aggiungiBatchApi(values);
        loader.endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    };

    const onSubmitForm = (values) => {
        if (batch) {
            aggiornBatch(values);
        } else {
            aggiungiBatch(values);
        }
    };

    const closeModal = () => setShow(false);

    return {
        initialFormValues,
        validationSchema,
        onSubmitForm,
        show,
        closeModal,
        modalMsg,
    };
};
